import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { BuscarActoPage } from './buscar-acto/buscar-acto.component';
import { ExternosPage } from './externos/externos.component';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';

@Component({
  selector: 'app-actos',
  imports: [
    CommonModule,
    BackboneComponent,
    BreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TabViewModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    IconFieldModule,
    InputIconModule,
    BuscarActoPage,
    ExternosPage,
    ShowForRolesDirective,
  ],
  templateUrl: './actos.component.html',
  styleUrl: './actos.component.scss',
})
export class ActosPage {}
